var _defs, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.83 34.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".instagram_svg{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "instagram_svg",
    d: "M25.36,34.83H9.47c-5.22,0-9.47-4.25-9.47-9.47V9.47C0,4.25,4.25,0,9.47,0h15.89c5.22,0,9.47,4.25,9.47,9.47v15.89c0,5.22-4.25,9.47-9.47,9.47ZM9.47,3.01c-3.56,0-6.45,2.9-6.45,6.45v15.89c0,3.56,2.9,6.45,6.45,6.45h15.89c3.56,0,6.45-2.9,6.45-6.45V9.47c0-3.56-2.9-6.45-6.45-6.45H9.47Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "instagram_svg",
    d: "M17.41,26.88c-4.98,0-9.04-4.05-9.04-9.04s4.05-9.04,9.04-9.04,9.04,4.05,9.04,9.04-4.05,9.04-9.04,9.04Zm0-15.22c-3.41,0-6.18,2.77-6.18,6.18s2.77,6.18,6.18,6.18,6.18-2.77,6.18-6.18-2.77-6.18-6.18-6.18Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "instagram_svg",
    cx: 26.73,
    cy: 8.32,
    r: 2.14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.cd54089638a7e9ea7024ce60c31ce201.svg";
export { ForwardRef as ReactComponent };